import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { SkillSubscriptionRecord } from "../SkillRecord";

import { skillsQueryKey } from "./useSkills";

interface Args {
  skillId: string;
}

/** Subscribe the caller to a skill. Idempotent. Invalidates both tab listings. */
export function useSubscribeSkill(orgId: string | undefined) {
  const { skillService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<SkillSubscriptionRecord, Error, Args>({
    mutationFn: ({ skillId }) => skillService.subscribe(skillId, { orgId }),
    onSuccess: () => {
      // The subscribe action moves a row between Mine and Org tabs, so both
      // listings are stale. Untabbed listings (full visible set) keep their
      // skill but need the updated `subscription` field, so they're also
      // invalidated.
      void queryClient.invalidateQueries({ queryKey: skillsQueryKey(orgId) });
    },
  });
}
